import { ConfirmationModal, ConfirmationModalVariant } from "../ConfirmationModal";
import { usePlayground } from "../Playground/playground-store";

interface FormatChangeConfirmationProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const FormatChangeConfirmation: React.FC<FormatChangeConfirmationProps> = ({
  isOpen,
  setIsOpen,
}) => {
  try {
    const playground = usePlayground();

    const handleConfirmFormatChange = () => {
      playground.setTemplateFormat("jinja2");
      setIsOpen(false);
    };

    return (
      <ConfirmationModal
        title="Change Template Format"
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        leaveButtonText="Cancel"
        saveButtonText="Change Format"
        handleOnConfirm={handleConfirmFormatChange}
        headerVariant={ConfirmationModalVariant.warning}
        saveButtonVariant="default"
        exitButtonVariant="outline"
        useBlocker={false}
        MarkdownDescription={
          <span>
            Changing the template format to jinja2 may require you to update your variable syntax
            from <code className="font-mono">{"{variable}"}</code> to{" "}
            <code className="font-mono">{"{{variable}}"}</code>. Are you sure you want to continue?
            <p className="mt-4">
              Learn more about Jinja2 template variables in our{" "}
              <a
                href="https://docs.promptlayer.com/features/prompt-registry/template-variables"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 hover:underline"
              >
                documentation
              </a>
              .
            </p>
          </span>
        }
      />
    );
  } catch {
    return null; // Don't render if there is no valid playground context.
  }
};

export default FormatChangeConfirmation;
